// src/pages/Courses/CourseRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { coursesAPI } from "api/Interactions/CoursesAPI";

interface Person {
  id: number;
  first_name: string;
  last_name: string;
  phone?: string;
}

interface CoursesRightDrawerProps {
  courseId: number;
  externalLink?: string;
}

const CoursesRightDrawer: React.FC<CoursesRightDrawerProps> = ({
  courseId,
  externalLink = "https://example.com",
}) => {
  const theme = useTheme();

  // 🔹 Fetch list of people associated with this course record
  const fetchPeople = async () => {
    const response = await coursesAPI.getById(courseId);
    const people: Person[] = (response as any).people || [];
    return people.map((p) => ({
      id: p.id,
      primary: `${p.first_name} ${p.last_name}`,
      secondary: p.phone || "",
    }));
  };

  // 🔹 Define what happens when the user clicks the action button
  const handleSendCourses = async (selectedPeople: any[]) => {
    // Example placeholder: Replace with your real backend logic
    alert(`Courses sent to ${selectedPeople.length} people`);
  };

  return (
    <ActionOnRecord
      fetchData={fetchPeople}
      onAction={handleSendCourses}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Send Courses"
      externalLink={externalLink}
    />
  );
};

export default CoursesRightDrawer;
